import { RouteRecordRaw } from 'vue-router';

import LabCer from '@/views/lab/LabCer.vue';
import LabMic from '@/views/lab/LabMic.vue';
import LabScroll from '@/views/lab/LabScroll.vue';

// TODO: 테스트 종료시, 라우터 삭제 부탁드립니다.
export default function labRoutes(): RouteRecordRaw[] {
  return [
    // CER
    {
      path: '/lab/cer',
      name: 'beta-cer',
      component: LabCer,
    },
    // 마이크
    {
      path: '/lab/mic',
      name: 'lab-mic',
      component: LabMic,
    },
    // 스크롤
    {
      path: '/lab/scroll',
      name: 'lab-scroll',
      component: LabScroll,
    },
  ];
}
